/* eslint-disable no-unused-vars */
import React from 'react';
import style from './gridSection.module.scss';
import { Link } from 'react-router-dom';
import { PossibleAction, ResourceName } from 'store/types';
import { useAppSelector } from 'store/hooks';
import { selectResourceByName } from 'store/page/pageSlice';
import { useContentAdapter } from 'hooks/useContentAdapter';
import includes from 'lodash-es/includes';
import { getCommonOmitActions, getUploadedOmitActions } from 'utils/hooked';
import Grid2 from 'components/grid/grid2';
import { useResourceReRequest } from 'hooks/useResourceReRequest';

export default function GridSection(props: {
  text: string;
  href: string;
  resourceName: ResourceName;
  shouldImagesScroll?: boolean;
}) {
  const selector = selectResourceByName.bind(null, props.resourceName);
  const omitedCommon = getCommonOmitActions();
  const omitedUpload = getUploadedOmitActions();

  const omitChecker =
    props.resourceName === 'only_uploaded' ? omitedUpload : omitedCommon;

  const resource = useAppSelector(selector);
  const images = useContentAdapter(resource?.data || {}, {
    actions: (['edit', 'download', 'delete'] as PossibleAction[]).filter(
      (action: PossibleAction) => !includes(omitChecker, action)
    ),
  });

  useResourceReRequest(resource);

  return (
    <div className={style.container}>
      <div className={style.header}>
        <span>{props.text}</span>
        <Link className={'font18 clickable-text'} to={props.href}>
          Показать все
        </Link>
      </div>
      <Grid2
        shouldImagesScroll={props.shouldImagesScroll}
        images={images}
      ></Grid2>
    </div>
  );
}
